module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/btn_save-41ef961f9e67e38c0be66d6160c8256c.svg";